module.exports = __webpack_public_path__ + "img/Logo-vimo.0cb92e90.svg";